const types = [
  {
    title: "Ethos Sales & Distribution",
    mobile: true,
    desc: "An integrated sales and distribution system designed to optimize order processing, inventory management, and product delivery across the supply chain.",
    speed: "Slow",
    icon: "/images/slider/sliderSales.png",
  },
  {
    title: "Ethos Delivery System",
    mobile: true,
    desc: "A streamlined delivery system ensuring timely and efficient transportation of goods from origin to destination.",
    speed: "Slow",
    icon: "/images/slider/sliderSales.png",
  },
  {
    title: "Ethos Warehouse Management",
    mobile: true,
    desc: "A robust warehouse management system that streamlines inventory tracking, space utilization, and order fulfillment for enhanced operational efficiency.",
    speed: "Slow",
    icon: "/images/slider/sliderWhse.png",
  },
  {
    title: "ERP Implementation",
    mobile: true,
    desc: "Comprehensive ERP implementation services that align business processes, enhance data visibility, and drive operational efficiency across departments.",
    speed: "Slow",
    icon: "/images/slider/sliderSales.png",
  },
  {
    title: "Ethos HR & Payroll",
    mobile: true,
    desc: "A complete HR and payroll solution to manage employee records, streamline payroll processing, and ensure compliance with labor regulations.",
    speed: "Slow",
    icon: "/robot-mini.png",
  },
  {
    title: "Ethos Production Automation Solution",
    mobile: true,
    desc: "An intelligent production automation solution that enhances manufacturing efficiency, reduces manual intervention, and ensures consistent product quality.",
    speed: "Slow",
    icon: "/robot-mini.png",
  },
];

export function DeliveryTypes() {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Products</h2>
      <div className="grid md:grid-cols-3 gap-4">
        {types.map((t, i) => (
          <div
            key={i}
            className="bg-white p-4 rounded-xl shadow hover:shadow-lg transition"
          >
            {/* <img
              src={t.icon}
              alt={t.title}
              className="w-200 h-20 mx-auto mb-4"
            /> */}
            <h3 className="text-lg font-bold">{t.title}</h3>
            <p className="text-sm text-gray-600">{t.desc}</p>
            {/* <p className="text-sm text-gray-400 mt-1">Delivery: {t.speed}</p> */}
          </div>
        ))}
      </div>
    </div>
  );
}
